import React from "react";
import { GlobeIcon } from "lucide-react";
import { images } from "../../data/content";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
export function FinalCta() {
  return <section className="w-full bg-navy px-4 py-16 sm:py-20" data-id="element-137" data-mp="1nmviyfijlb27">
      <div className="mx-auto max-w-2xl text-center" data-id="element-138" data-mp="1smrpomimjglg">
        <p className="text-base font-bold uppercase tracking-wide text-white/70" data-id="element-139" data-mp="1eobbkaifmnta">Ready to stop asking…</p>
        <h2 className="mt-2 font-serif text-4xl font-black leading-tight text-white sm:text-5xl" data-id="element-140" data-mp="1ipn3imos3l4n">
          <em className="text-[#5aa2ff]" data-id="element-141" data-mp="14qdmjksr0mzm">"Should I take this case?"</em>
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-white/80" data-id="element-142" data-mp="19p70feby6g0b">
          …and start reviewing your implant cases with a structured decision process that helps you evaluate what matters, identify what's still unresolved,
          and reach a clear ACCEPT / PREPARE / REFER decision before committing to treatment.
        </p>

        <img src={images.mockup} alt="Implant Case Decision complete system" className="mx-auto mt-8 w-full max-w-lg" data-id="element-143" data-mp="28bl0lzlcs12" />

        <p className="mt-6 font-serif text-6xl font-black text-white" data-id="element-144" data-mp="3tempks3t8ax5">
          $27 <span className="font-sans text-xl font-bold text-white/70" data-id="element-145" data-mp="b1oouiz71e1x">USD</span>
        </p>
        <p className="mt-2 text-[15px] font-semibold text-white/80" data-id="element-146" data-mp="6zbknz03ho79">6 Premium Volumes + 5 Bonuses</p>

        <div className="mx-auto mt-6 max-w-xl" data-id="element-147" data-mp="3fev7af69g8dc">
          <CtaButton label="Yes — I want Implant Case Decision™" data-id="element-148" data-mp="3fhr5m4m0sz2b" />
          <p className="mt-3 text-sm text-white/70" data-id="element-149" data-mp="3ahlin1qp40qk">Immediate Access · Lifetime Access · 7-Day Guarantee</p>
        </div>

        <div className="mt-8" data-id="element-150" data-mp="3ohmmmq29boa9">
          <Countdown dark data-id="element-151" data-mp="3jh8dt5su0ab6" />
        </div>

        <div className="mx-auto mt-6 max-w-xl" data-id="element-152" data-mp="3jg6ygp4s91nn">
          <ScarcityBar dark data-id="element-153" data-mp="3jjl2s2x0bkxq" />
          <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-white/70" data-id="element-154" data-mp="13pkq80zpju51">
            <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-155" data-mp="yrj04w3v6uk2" />
            Currency conversion is handled automatically for your country.
          </p>
        </div>
      </div>
    </section>;
}